/* eslint-disable no-param-reassign */
/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import { set } from 'lodash-es';
import {
  findInvoiceItemById as _findInvoiceItemById,
  findInvoiceItemPaymentById,
  findAllInvoiceItems,
} from '@/services/api/payment/invoice';

// initial state
const state = {
  invoices: [],
  invoicesItems: [],
};

// getters
const getters = {
  get: (state) => state.invoices,
  items: (state) => state.invoicesItems,
  pending: (state) => state.invoices.filter((invoice) => invoice.status === 'PENDING'),
};

// actions
const actions = {
  async setInvoicesItems({ commit }) {
    const { data: invoicesItems } = await findAllInvoiceItems();
    commit('SET_VALUE', { invoicesItems });
  },
  async findInvoiceItemById(unset, id) {
    const { data: invoice } = await _findInvoiceItemById(id);
    const { data: payments } = await findInvoiceItemPaymentById(id);
    Object.assign(invoice, { payments });
    return invoice;
  },
  setValue({ commit }, object) {
    commit('SET_VALUE', object);
  },
  setValueWithPath({ commit }, object) {
    commit('SET_VALUE_WITH_PATH', object);
  },
  clear({ commit }) {
    commit('CLEAR');
  },
};

// mutations
const mutations = {
  SET_VALUE(state, object) {
    const [key] = Object.keys(object);
    state[key] = object[key];
  },
  SET_VALUE_WITH_PATH(state, { value, path }) {
    set(state, path, value);
  },
  CLEAR(state) {
    Object.assign(state, {
      invoices: [],
      invoicesItems: [],
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
